// src/hooks/useEvent.js
import {useQuery} from "react-query";
import {fetchEventList, fetchSelectEventList} from "../api/eventApi";

export const useEventList = (pageNumber, pageSize) => {
    return useQuery(['eventList', pageNumber, pageSize], () => fetchEventList(pageNumber, pageSize), {
        refetchOnWindowFocus: false, // 根據需求調整
    });
}

export const useSelectEventList = (pageNumber, pageSize) => {
    return useQuery(['selectEventList', pageNumber, pageSize], () => fetchSelectEventList(pageNumber, pageSize), {
        refetchOnWindowFocus: false, // 根據需求調整
    });
}
